
const initialState ={
  data:[],
  reportdata:[],
}
const DOrganisationReducer =(state = initialState, action: any) => {
  switch (action.type) {
    case 'FETCH_DATA_SUCCESS':
      return { ...state, data: action.payload };
      case 'fetch_data_Add_success':
              return { ...state, reportdata: action.payload };
      
    default:
      return state;
  }
};
export default DOrganisationReducer;